import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import useApi from "../customHooks/useAPI";

const PatientRequests = () => {
    const [patientRequestData, setPatientRequestData] = useState([]);
    const [searchQuery, setSearchQuery] = useState(""); // 🔍 New state
    const { doctorId } = useAuth();
    const {callApi} = useApi();

    const fetchRequests = async () => {
        try {
            const response = await callApi({
                url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/doctor/patientAffiliationRequest`,
                method: "GET",
                headers: { "Doctor-Id": doctorId },
            });

            console.log(response);
            

            if (response.status === 200) {
                setPatientRequestData(response.data);
            }
        } catch (error) {
            console.error("Error fetching requests:", error);
        }
    };

    const handleRequestAction = async (affiliationId, action) => {
        const myHeaders = {
            "Doctor-Id": doctorId,
            "Content-Type": "application/json"
        }

        const raw = JSON.stringify({
            affiliation_id: affiliationId,
            status: action,
        });

        await callApi({
            url: `${process.env.REACT_APP_BACKEND_ENDPOINT}/doctor/patientAffiliationRequest`,
            method: "POST",
            headers: myHeaders,
            body: raw,
        });

        fetchRequests();
    };

    useEffect(() => {
        fetchRequests();
    }, []);

    // 🔍 FILTER LOGIC
    const filteredData = patientRequestData.filter((item) => {
        const fullName =
            `${item.patient.first_name} ${item.patient.last_name}`.toLowerCase();

        return (
            fullName.includes(searchQuery.toLowerCase()) ||
            String(item.patient.id).includes(searchQuery)
        );
    });

    return (
        <div className="pt-20 min-h-screen mx-auto">
            <h2 className="text-center text-2xl font-bold mb-4">
                Patient Affiliation Requests
            </h2>

            {/* 🔍 SEARCH BAR */}
            <input
                type="text"
                placeholder="Search by name or patient ID..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full mb-4 px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
            />

            {filteredData.length === 0 ? (
                <p className="text-gray-500 text-center">No matching requests found.</p>
            ) : (
                <div className="space-y-4">
                    {filteredData.map((item) => (
                        <div
                            key={item.id}
                            className="flex items-center justify-between bg-white shadow-md rounded-lg px-6 py-4 border hover:shadow-lg transition-all"
                        >
                            <div className="flex items-center gap-3 p-3">
                                <img
                                    src={item.patient.image_url}
                                    alt="Profile pic"
                                    className="w-12 h-12 rounded-full object-cover border border-gray-300"
                                />
                                <div className="flex flex-col">
                                    <span className="text-lg font-semibold text-gray-900">
                                        {item.patient.first_name} {item.patient.last_name}
                                    </span>
                                    {item.patient.email && (
                                        <span className="text-sm text-gray-500">
                                            {item.patient.email}
                                        </span>
                                    )}
                                    <span className="text-xs text-gray-400">
                                        Patient ID: {item.patient.id}
                                    </span>
                                </div>
                            </div>

                            <div className="flex space-x-2">
                                <button
                                    onClick={() =>
                                        handleRequestAction(item.doctorPatientAffiliation.id, "ACCEPTED")
                                    }
                                    className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded hover:bg-green-600 transition"
                                >
                                    Accept
                                </button>

                                <button
                                    onClick={() =>
                                        handleRequestAction(item.doctorPatientAffiliation.id, "REJECTED")
                                    }
                                    className="px-4 py-2 text-sm font-semibold text-white bg-red-500 rounded hover:bg-red-600 transition"
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PatientRequests;
